import { forwardRef } from 'react';
import MuiIconButton from '@mui/material/IconButton';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import type { LucideIcon } from 'lucide-react';
import { Icon } from './Icon';

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'children' | 'aria-label'> {
  icon: LucideIcon;
  /** Solid glyph, for a toggled state such as a starred item. */
  iconFilled?: boolean;
  /** Required: an icon button has no visible text, so the name is the label. */
  label: string;
}

/** 36px visual, 44px hit area (theme), and always named. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, label, iconFilled, ...rest },
  ref,
) {
  return (
    <MuiIconButton ref={ref} aria-label={label} {...rest}>
      <Icon icon={icon} {...(iconFilled ? { filled: true } : {})} />
    </MuiIconButton>
  );
});
